const productCategory = [
 { id: 1, label: "Seeds", value: "seeds" },
 { id: 2, label: "Crop Protection", value: "crop-protection" },
 { id: 3, label: "Crop Nutrition", value: "crop-nutrition" },
 { id: 4, label: "Equipment", value: "equipment" },
 { id: 5, label: "Animal Husbandry", value: "animal-husbandry" },
 { id: 6, label: "Organic", value: "organic" },
 { id: 7, label: "Fertilizers", value: "fertilizers" },
 { id: 8, label: "Pesticides", value: "pesticides" },
 { id: 9, label: "Tools", value: "tools" },
 { id: 10, label: "Irrigation", value: "irrigation" },
 { id: 11, label: "Storage", value: "storage" },
 { id: 12, label: "Services", value: "services" },
]


export default productCategory